import React, { useState, useEffect, useRef, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux';

import _ from 'lodash';
import cx from 'classnames';
import { guid } from 'services/util';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import Truncate from 'react-truncate';

import { Property } from '../../../components/properties';
import Actions from '../../../components/actions';

import { EditorContext } from '../../../index';
import SortableTree from './Components/sortableTree';
import { updateWidgetContent } from 'actions/editor';

import { Button } from "react-bootstrap";

import styles from './menuList.module.scss';


const ManageMenu = ({ id, widget, position, ...rest }) => {
  const dispatch = useDispatch();

  const editorContext = React.useContext(EditorContext);
  const editorSession = editorContext.editorSession.id;

  const menuContent = _.get(widget, 'content', []);
  const [state, setState] = useState({
    menuAction: false,
    value: {}
  });

  const modalReference = React.useRef();

  const handleOnChangeValue = (nodes, targetid, type, value) => {
    const childMenus = (nodes || []).map((element) => {
      if (element.uid === targetid) {
        return {
          ...element,
          [type]: value
        }
      }
      return {
        ...element,
        children: handleOnChangeValue(element.children, targetid, type, value)
      };
    });

    if(_.size(childMenus) === 0){
      return null;
    }
    
    return childMenus;
  };

  const addMenuItem = () => {
    var updatedMenu = [
      ...menuContent,
      {
        uid: guid(),
        name: 'Untitled',
        action: null,
        children: null
      }
    ]

    dispatch(updateWidgetContent(editorSession, id, updatedMenu))
  }

  const handleMenuDialog = (menuAction) => {
    setState(state => {
      return {
        menuAction: true,
        value: menuAction
      }
    });
  }

  const closePopup = () => {
    setState(state => {
      return {
        menuAction: false,
        value: {}
      }
    });
  }

  const handleActionChange = (action) => {
    var selectedMenu = _.get(state.value, 'uid')
    const updatedAction = handleOnChangeValue(menuContent, selectedMenu, 'action', action)

    dispatch(updateWidgetContent(editorSession, id, updatedAction));
  }

  return (
    <>
      <Property.Dialog
        width={253}
        ref={modalReference}
        className={styles.menuDialog}
        target={`#${id}`}
        title='Manage Items'
        onCancel={rest.onCancel}
      >
        <Property.Body>
          <MenuListContainer
            menuContent={menuContent}
            onChangeName={handleOnChangeValue}
            onChangeAction={handleMenuDialog}
            widgetId={id}
          />
          <div className={styles.actionConatiner}>
            <Button className={styles.addButton} onClick={addMenuItem} variant='primary'>
              <i className={cx('cleverstory-plus', styles.iconMore)} />
              Add item
            </Button>
          </div>
        </Property.Body>
      </Property.Dialog>

      {modalReference.current && state.menuAction &&
        <Actions
          target={modalReference.current.id}
          editorSession={editorSession}
          value={_.get(state.value, 'action')}
          onChange={handleActionChange}
          onCancel={() => {
            closePopup()
          }}
        />
      }
    </>
  );
}


const MenuListContainer = ({ menuContent, widgetId, onChangeAction, onChangeName }) => {
  const dispatch = useDispatch();

  const editorContext = React.useContext(EditorContext);
  const editorSession = editorContext.editorSession.id;

  const [menuList, setMenuList] = useState(menuContent)

  useEffect(() => {
    if (menuContent) {
      setMenuList(menuContent);
    }
  }, [menuContent])

  const moveCard = (dragId, hoverId, parent) => {

    if (dragId === hoverId) return

    let menuTree = menuList.map(obj => {
      if (obj.children === null) {
        return { ...obj, children: null }; 
      }
      return obj;
    });

    const removeNode = (id, items) => {
      for (const node of items) {
        if (node.uid == id) {
          items.splice(items.indexOf(node), 1)
          return;
        }

        if (node.children && node.children.length) {
          removeNode(id, node.children)
        }
      }
    }

    const item = {...findItem(dragId, menuTree)}
    if (!item.uid) {
      return;
    }

    const dest = parent ? findItem(parent, menuTree).children : menuTree

    if (!hoverId) {
      removeNode(dragId, menuTree)
      dest.push(item)
    } else {
      const index = dest.indexOf(dest.filter(v => v.uid == hoverId).shift())
      removeNode(dragId, menuTree)
      dest.splice(index, 0, item)
    }

    dispatch(updateWidgetContent(editorSession, widgetId, menuTree));
  }

  const findItem = (id, items) => {
    for (const node of items) {
      if (node.uid == id) return node
      if (node.children && node.children.length) {
        const result = findItem(id, node.children)
        if (result) {
          return result
        }
      }
  
    }

    return false
  }

  return (
    <DndProvider backend={HTML5Backend}>
      <SortableTree
        parent={null}
        show={true}
        menuContent={menuList}
        contentList={menuList}
        onChangeName={onChangeName}
        onChangeAction={onChangeAction}
        widgetId={widgetId}
        editorSession={editorSession}
        moveCard={moveCard}
        findItem={findItem}
      />
    </DndProvider>
  )
}

export default ManageMenu